import { connect, ConnectedProps } from "react-redux";
import { withRouter } from "react-router";
import { IStoreState } from "../../../../reducers/types";

import { ReviewHotelItinerary } from "./component";

import {
  getHotelShopChosenProduct,
  getSelectedPackageByLodgingId,
} from "../../../hotel-shop/reducer";
import {
  getPackageAvailabilityAdultsCount,
  getPackageAvailabilityChildren,
  getPackageAvailabilityInfants,
} from "../../../availability/reducer";
import { getPackagedRoomComponent } from "../../../package-identity/reducer/selectors";
import { getPackageHotelIdentity } from "../../../hotel-shop/utils/usePackageHotelIdentity";

const mapStateToProps = (state: IStoreState) => {
  const packagedRoomComponentV2 = getPackagedRoomComponent(state);
  const hotelIdentity = getPackageHotelIdentity(state);

  return {
    chosenProduct: getHotelShopChosenProduct(state),
    selectedPackageByLodging: getSelectedPackageByLodgingId(state),
    searchAdultsCount: getPackageAvailabilityAdultsCount(state),
    searchChildren: getPackageAvailabilityChildren(state),
    searchedInfants: getPackageAvailabilityInfants(state),
    packagedRoomComponentV2,
    selectedLodging: hotelIdentity.selectedLodging,
    roomInfo: hotelIdentity.selectedRoom,
    cancellationSummary: hotelIdentity.cancellationSummary,
    cancellationPolicyV2: hotelIdentity.cancellationPolicyV2,
    checkIn: hotelIdentity.checkIn,
    checkOut: hotelIdentity.checkOut,
  };
};

export const mapDispatchToProps = {};

const connector = connect(mapStateToProps, mapDispatchToProps);
export type ReviewHotelItineraryConnectorProps = ConnectedProps<
  typeof connector
>;

export const ConnectedReviewHotelItinerary = withRouter(
  connector(ReviewHotelItinerary)
);
